import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { breadcrumbNavigation } from './data/breadcrumbNavigation.interface';

@Component({
	selector: 'msp-breadcrumb-navigation',
	standalone: true,
	imports: [RouterLink],
	templateUrl: './breadcrumb-navigation.component.html',
	styleUrl: './breadcrumb-navigation.component.scss',
})
export class BreadcrumbNavigationComponent {
	@Input() breadcrumb: breadcrumbNavigation[] = [];
}
